
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.6 4.2H5.4V3h1.2v1.2zm0 4.8H5.4V5.4h1.2V9zm-.594 3A5.997 5.997 0 0012 6c0-3.312-2.682-6-5.994-6A6.003 6.003 0 000 6c0 3.312 2.688 6 6.006 6zM6 1.2c2.652 0 4.8 2.148 4.8 4.8 0 2.652-2.148 4.8-4.8 4.8A4.799 4.799 0 011.2 6c0-2.652 2.148-4.8 4.8-4.8z","fill":"currentColor"}})])
          )
        }
      }
    